import React from 'react';

export function Card({ title, icon, altText='Card icon image', children }) {
  return (
    <div
      className="panel"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      {icon ? (
        <div className="card-icon">
          <img src={icon} alt={altText} />
        </div>
      ) : null}
      <div className="card-title">{title}</div>
      <div>{children}</div>
    </div>
  );
}
